/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AnalysisProcess
 */
export interface AnalysisProcess {
  /**
   *
   * @type {string}
   * @memberof AnalysisProcess
   */
  readonly uuid: string;
  /**
   *
   * @type {Date}
   * @memberof AnalysisProcess
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof AnalysisProcess
   */
  readonly updated?: Date;
  /**
   *
   * @type {Date}
   * @memberof AnalysisProcess
   */
  analysesDate: Date;
  /**
   *
   * @type {string}
   * @memberof AnalysisProcess
   */
  analyticalTechnique?: string | null;
  /**
   *
   * @type {string}
   * @memberof AnalysisProcess
   */
  validationMethod?: string | null;
  /**
   *
   * @type {string}
   * @memberof AnalysisProcess
   */
  laboratoryResearch: string;
  /**
   *
   * @type {string}
   * @memberof AnalysisProcess
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the AnalysisProcess interface.
 */
export function instanceOfAnalysisProcess(value: object): value is AnalysisProcess {
  if (
    (!("analysesDate" in (value as Record<string, any>)) &&
      !("analyses_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["analysesDate"] === undefined &&
      (value as Record<string, any>)["analyses_date"] === undefined)
  )
    return false;
  if (
    (!("laboratoryResearch" in (value as Record<string, any>)) &&
      !("laboratory_research" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["laboratoryResearch"] === undefined &&
      (value as Record<string, any>)["laboratory_research"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function AnalysisProcessFromJSON(json: any): AnalysisProcess {
  return AnalysisProcessFromJSONTyped(json, false);
}

export function AnalysisProcessFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AnalysisProcess {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    analysesDate: new Date(json["analyses_date"]),
    analyticalTechnique:
      json["analytical_technique"] === undefined
        ? undefined
        : json["analytical_technique"] === null
        ? null
        : json["analytical_technique"],
    validationMethod:
      json["validation_method"] === undefined
        ? undefined
        : json["validation_method"] === null
        ? null
        : json["validation_method"],
    laboratoryResearch: json["laboratory_research"],
    dataOwner: json["data_owner"],
  };
}

export function AnalysisProcessToJSON(json: any): AnalysisProcess {
  return AnalysisProcessToJSONTyped(json, false);
}

export function AnalysisProcessToJSONTyped(
  value?: Omit<AnalysisProcess, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    analyses_date: value["analysesDate"].toISOString().substring(0, 10),
    analytical_technique: value["analyticalTechnique"],
    validation_method: value["validationMethod"],
    laboratory_research: value["laboratoryResearch"],
    data_owner: value["dataOwner"],
  };
}
